import { Delete, DeleteForever, Deselect } from "@mui/icons-material";
import { Box, Button, IconButton, Paper, Typography } from "@mui/material";
import { useState } from "react";
import { Part } from "../../models/Part";

export const CatalogsActionsHeader = ({
	selectedRows,
	handleClearSelection,
	handleDelete,
	isDeletingAll,
	isLoading,
}: {
	selectedRows: Part[];
	handleClearSelection: () => void;
	handleDelete: () => void;
	isDeletingAll: boolean;
	isLoading: boolean;
}) => {
	const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

	return (
		<>
			<Paper
				elevation={2}
				sx={{
					px: 1,
					py: 0.5,
					mb: 0.5,
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
				}}
			>
				<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
					<IconButton
						size="small"
						onClick={handleClearSelection}
						title="Deselect All"
					>
						<Deselect fontSize="small" />
					</IconButton>
					<Typography variant="body2" color="text.secondary" fontWeight={500}>
						{selectedRows.length} selected {isDeletingAll ? "(all)" : ""}
					</Typography>
				</Box>
				<Box sx={{ display: "flex", gap: 0.5 }}>
					{isDeletingAll ? (
						<Button
							variant="outlined"
							color="error"
							size="small"
							startIcon={<DeleteForever />}
							onClick={handleDelete}
							disabled={isLoading}
							sx={{
								fontSize: "0.75rem",
								py: 0.5,
								px: 1.5,
								textTransform: "none",
							}}
						>
							Delete All
						</Button>
					) : (
						<Button
							variant="outlined"
							color="warning"
							size="small"
							startIcon={<Delete />}
							onClick={handleDelete}
							disabled={isLoading}
							sx={{
								fontSize: "0.75rem",
								py: 0.5,
								px: 1.5,
								textTransform: "none",
							}}
							data-test-id="delete-selected-button"
						>
							Delete Selected ({selectedRows.length})
						</Button>
					)}
				</Box>
			</Paper>
		</>
	);
};
